import React, { Component } from 'react';
import {
  Menu,
  MenuItem,
  IconButton,
  CircularProgress
} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import MenuIcon from '@material-ui/icons/Menu';
import text from '../../texts/translations';

@inject('customerCaseStore')
@observer
class SimpleMenu extends Component {
  state = {
    anchorEl: null
  };

  componentDidMount() {
    // this.props.customerCaseStore.fetchTemplates(
    //   this.props.customerCaseStore.currentUser.templateRightsLevel
    // );
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    if (this.props.customerCaseStore.fetchTemplatesState !== 'done') {
      return <CircularProgress />; // wait until the fetch is done and the store is updated
    } else {
      const { anchorEl } = this.state;
      return (
        <div>
          <IconButton
            color="inherit"
            aria-label="Menu"
            aria-owns={anchorEl ? 'simple-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
          >
            {this.props.customerCaseStore.templates.viewTemplates.map(
              template => {
                var templateNameLocalized = template.templateName;

                return (
                  <MenuItem
                    onClick={() =>
                      this.props.customerCaseStore.changeTemplateMode(
                        'viewTemplate',
                        template.templateName
                      )
                    }
                  >
                    {templateNameLocalized}
                  </MenuItem>
                );
              }
            )}
          </Menu>
        </div>
      );
    }
  }
}

export default withRouter(SimpleMenu);



// WEBPACK FOOTER //
// ./src/components/TemplateMenu/TemplateMenu.jsx